import React from 'react'

import { Notification, Icon, Text } from './styles'

const typeIconMap = {
  success: 'checkmark',
  error: 'exclamation',
  warn: 'exclamation',
  refresh: 'refresh',
}

const Component = ({ className, note = {}, noIcon = false, testId }) => (
  <Notification type={note.type} className={className} data-testid={testId}>
    {!noIcon && <Icon name={typeIconMap[note.type]} size="18" />}
    <Text>{note.text}</Text>
  </Notification>
)

Component.displayName = 'Notification'

export default Component
